import { Components, Theme } from '@mui/material/styles';

export const textFieldTheme: Components<Theme>['MuiTextField'] = {
  defaultProps: {
    size: "small",
  },
};
